import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Plus, X, SearchIcon } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import FarmerColumn from "Common/Components/ColumnData/FarmerColumn";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
interface FormField {
  name: string;
  label: string;
  type: string;
  placeholder: string;
  colSpan: any;
}

const FarmerPage = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [national_id, setnational_id] = useState<any>();
  const [full_name, setfull_name] = useState<any>();
  const [father_name, setfather_name] = useState<any>();
  const [phone_number, setphone_number] = useState<any>();
  const [sheba_number_1, setsheba_number_1] = useState<any>();
  const [sheba_number_2, setsheba_number_2] = useState<any>();
  const [card_number, setcard_number] = useState<any>();
  const [address, setaddress] = useState<any>();
  const [IsEdit, setIsEdit] = useState<any>();
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const formFields: FormField[] = [
    {
      name: "national_id",
      label: "کد ملی",
      type: "text",
      placeholder: "کد ملی را وارد کنید",
      colSpan: 6, // اضافه کردن prop جدید برای کنترل عرض
    },

    {
      name: "phone_number",
      label: "شماره همراه",
      type: "text",
      placeholder: "شماره همراه را وارد کنید",
      colSpan: 6,
    },
    {
      name: "father_name",
      label: "نام پدر",
      type: "text",
      placeholder: "نام پدر را وارد کنید",
      colSpan: 6,
    },
    {
      name: "full_name",
      label: "نام",
      type: "text",
      placeholder: "نام و نام خانوادگی را وارد کنید",
      colSpan: 6,
    },
    {
      name: "card_number",
      label: "شماره کارت",
      type: "text",
      placeholder: "شماره کارت را وارد کنید",
      colSpan: 12, // عرض کامل برای فیلدهای مهم
    },
    {
      name: "sheba_number_1",
      label: "شبا اول",
      type: "text",
      placeholder: "شماره شبا اول را وارد کنید",
      colSpan: 12,
    },
    {
      name: "sheba_number_2",
      label: "شبا دوم",
      type: "text",
      placeholder: "شماره شبا دوم را وارد کنید",
      colSpan: 12,
    },
    {
      name: "address",
      label: "آدرس",
      type: "text",
      placeholder: "آدرس را وارد کنید",
      colSpan: 12,
    },
  ];

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;

    // اطمینان از اینکه alldata مقدار عددی معتبر دارد
    const totalItems = alldata ? Number(alldata) : 0;

    // بررسی اینکه صفحه فعلی با تعداد داده‌ها و سایز جدید هماهنگ باشد
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize)); // تنظیم صفحه به آخرین صفحه موجود
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(newPage, newSize);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  // Get Data
  const fetchData = async (page: any, size: any) => {
    try {
      // ساخت URL پایه
      let url = `https://api.havirkesht.ir/farmer/?sort_by=updated_at&sort_order=desc&size=${size}&page=${page}`;
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }
      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });

      const items = res?.data?.items || [];
      setData(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setload(items.length < 1); // اصلاح شده به <1 به جای <0
    } catch (error: any) {
      setData("");
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setErrorMessage("خطایی رخ داده است");
      setload(true);
    }
  };
  // fetchData(currentPage, selectedNumber);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.national_id) {
      setEventData(cell.national_id);
    }
  };

  const handleUpdateDataClick = (ele: Partial<any>) => {
    setEventData({ ...ele });
    setnational_id(ele.national_id);
    setfull_name(ele.full_name);
    setfather_name(ele.father_name);
    setphone_number(ele.phone_number);
    setsheba_number_1(ele.sheba_number_1);
    setsheba_number_2(ele.sheba_number_2);
    setcard_number(ele.card_number);
    setaddress(ele.address);
    setIsEdit(true);
    setShow(true);
  };

  const handleDelete = async () => {
    if (!eventData) {
      toast.error("داده‌ای برای حذف انتخاب نشده است");
      setDeleteModal(false);
      return;
    }

    try {
      const evenDataNumber = Number(eventData);
      if (isNaN(evenDataNumber)) {
        toast.error("شناسه کشاورز معتبر نیست");
        return;
      }

      const res = await axios.delete(
        `https://api.havirkesht.ir/farmer/${evenDataNumber}`
      );

      if (res.status === 200) {
        Swal.fire({
          title: "حذف کشاورز",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      }
      await axios.delete(
        `https://api.havirkesht.ir/users/by_username/${evenDataNumber}`
      );
    } catch (error: any) {
      if (error.response) {
        // سرور پاسخ داده اما با کد خطا
        if (error.response.status === 409) {
          toast.error("لطفا ابتدا قرارداد کشاورز را حذف کنید");
        } else if (error.response.status === 500) {
          Swal.fire({
            title: "مشکلی در حذف این فیلد",
            text: "شما نمیتوانید این داده را حذف کنید لطفا با مدیر سایت تماس بگیرید",
            icon: "error",
          });
        } else {
          toast.error(`خطای سرور: ${error.response.status}`);
        }
      } else if (error.request) {
        toast.error("پاسخی از سرور دریافت نشد");
      } else {
        toast.error("خطا در ارسال درخواست");
      }
    } finally {
      setDeleteModal(false);
      setEventData(null);
    }
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      national_id: IsEdit ? national_id || "" : "",
      full_name: IsEdit ? full_name || "" : "",
      father_name: IsEdit ? father_name || "" : "",
      phone_number: IsEdit ? phone_number || "" : "",
      sheba_number_1: IsEdit ? sheba_number_1 || "" : "",
      sheba_number_2: IsEdit ? sheba_number_2 || "" : "",
      card_number: IsEdit ? card_number || "" : "",
      address: IsEdit ? address || "" : "",
    },
    validationSchema: Yup.object({
      national_id: Yup.string()
        .required("این فیلد را ضروری است")
        .matches(/^[0-9]{10}$/, "کد ملی باید 10 رقم باشد"),
      full_name: Yup.string().required("این فیلد ضروری است"),
      father_name: Yup.string().required("لطفاً نام پدر را وارد کنید"),
      phone_number: Yup.string()
        .required("این فیلد ضروری است")
        .matches(/^[0-9]{11}$/, "شماره تماس باید 11 رقم باشد"),
      // sheba_number_1: Yup.string().required("لطفاً شماره شبا اول را وارد کنید"),
      //   sheba_number_2: Yup.string().required("لطفاً شماره شبا دوم را وارد کنید"),
      // card_number: Yup.string()
      //   .required("لطفاً شماره کارت را وارد کنید")
      //   .matches(/^[0-9]{16}$/, "شماره کارت باید 16 رقم باشد"),
      address: Yup.string().required("لطفاً آدرس را وارد کنید"),
    }),
    onSubmit: async (values) => {
      try {
        if (IsEdit) {
          setIsEdit(false);
          const national_idNumber = Number(values.national_id);
          if (isNaN(national_idNumber)) {
            toast.error("کد ملی باید یک عدد معتبر باشد");
            return;
          }
          const res = await axios.put(
            `https://api.havirkesht.ir/farmer/${national_idNumber}`,
            values
          );
          if (res.status === 200) {
            Swal.fire({
              title: "بروزرسانی کشاورز",
              text: "اطلاعات با موفقیت بروزرسانی شد",
              icon: "success",
            });
            setreload((prev) => !prev);
          }
        } else {
          const res = await axios.post(
            "https://api.havirkesht.ir/farmer/",
            values
          );

          if (res.status === 201) {
            Swal.fire({
              title: "ثبت کشاورز",
              text: "اطلاعات با موفقیت ثبت شد",
              icon: "success",
            });
            setreload(!reload);
            setnational_id("");
            setfull_name("");
            setfather_name("");
            setphone_number("");
            setsheba_number_1("");
            setsheba_number_2("");
            setcard_number("");
            setaddress("");
            try {
              const newrest2 = {
                username: values.national_id,
                password: values.national_id,
                fullname: values.full_name,
                email: `${values.national_id}@gimail.com`,
                role_id: 3,
                phone_number: values.phone_number,
                disabled: false,
              };
              const newres = await axios.post(
                "https://api.havirkesht.ir/users/admin/",
                newrest2
              );
            } catch (error) {
              console.log(error);
            }
          } else if (res.status === 409) {
            Swal.fire({
              title: "ثبت کشاورز",
              text: "کشاورز با این کد ملی قبلا ثبت شده است",
              icon: "error",
            });
          }
        }
      } catch (error: any) {
        console.error("Operation failed:", error);
        if (error.response) {
          if (error.response.status === 406) {
            Swal.fire({
              title: "ثبت کشاورز",
              text: "کشاورز با این کد ملی قبلا ثبت شده است",
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "ثبت کشاورز",
              text: `خطای سرور: ${error.response.status}`,
              icon: "error",
            });
          }
        } else if (error.request) {
          Swal.fire({
            title: "ثبت کشاورز",
            text: "ارتباط با سرور برقرار نشد",
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "ثبت کشاورز",
            text: "خطای غیرمنتظره رخ داده است",
            icon: "error",
          });
        }
      } finally {
        toggle(); // بستن مودال در هر حالت
        setIsEdit(false);
      }
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setIsEdit(false);
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = FarmerColumn({
    handleUpdateDataClick,
    onClickDelete,
  });
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت کشاورز" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
            <div className="w-full md:w-auto">
              <h6 className="text-15 mb-2">
                مجموع کشاورزان (
                <b className="total-Employs">{alldata?.toString()}</b>)
              </h6>

              <label className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                    {searchValue ? (
                      <X
                        size={15}
                        className="cursor-pointer"
                        onClick={() => setsearchValue("")}
                      />
                    ) : (
                      <SearchIcon size={15} />
                    )}
                  </span>
                </div>
              </label>
            </div>

            {/* بخش سمت راست - دکمه‌ها */}
            <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
              <div className="w-full sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>
              <div className="w-full sm:w-auto shrink-0">
                <Link
                  to="#"
                  onClick={toggle}
                  type="button"
                  className="block text-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
                >
                  <span className="align-middle rtl">ایجاد کشاورز جدید</span>{" "}
                  <Plus className="inline-block size-4 rtl" />
                </Link>
              </div>
            </div>
          </div>

          {/* بخش جدول */}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={data}
              customnumberfortable={9}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap "
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 dark:text-white first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5  last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}

          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[50rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            {IsEdit ? "به روز رسانی اطلاعات" : "مشخصات کشاورز"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-12 gap-4">
              {formFields.map((field: FormField, index: number) => (
                <div
                  key={index}
                  className={`col-span-12 flex gap-4 items-center lg:col-span-${
                    field.colSpan || 6
                  } text-gray-800`}
                >
                  <label className="inline-block whitespace-nowrap dark:text-white mr-1 mb-2 text-base font-medium">
                    {field.label}
                  </label>
                  <input
                    type={field.type}
                    className="form-input w-full placeholder-gray-400 placeholder:text-[12px]"
                    placeholder={field.placeholder}
                    name={field.name}
                    autoComplete="off"
                    onChange={validation.handleChange}
                    value={
                      validation.values[
                        field.name as keyof typeof validation.values
                      ]
                    }
                  />

                  {/* نمایش خطا زیر هر فیلد */}
                  {validation.touched[
                    field.name as keyof typeof validation.touched
                  ] &&
                    typeof validation.errors[
                      field.name as keyof typeof validation.errors
                    ] === "string" && (
                      <p className="text-red-400 text-sm mt-1">
                        {String(
                          validation.errors[
                            field.name as keyof typeof validation.errors
                          ]
                        )}
                      </p>
                    )}
                </div>
              ))}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex  justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {!!IsEdit ? "بروز رسانی " : " ثبت اطلاعات"}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default FarmerPage;
